import {environment} from '../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {DadConfig} from '../models/models';
import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';

@Injectable()
export class DadConfigService {

  constructor(private httpClient: HttpClient) {
  }

  getDadConfig(dadConfigName: string): Observable<DadConfig> {
    return this.httpClient.get<DadConfig>(environment.baseUrlWs + '/api/dad-config?name=' + dadConfigName);
  }

  updateDadConfig(dadConfigId: number, dadConfig: DadConfig): Observable<DadConfig> {
    return this.httpClient.put<DadConfig>(environment.baseUrlWs + '/api/dad-config/' + dadConfigId + '/edit', dadConfig);
  }

  createDadConfig(dadConfig: DadConfig): Observable<DadConfig> {
    return this.httpClient.post<DadConfig>(environment.baseUrlWs + '/api/dad-admin/dad-config', dadConfig);
  }

  getAllDadConfigsNames(): Observable<string[]> {
    return this.httpClient.get<string[]>(environment.baseUrlWs + '/api/dad-config-names');
  }

  getActiveDadConfigsForUserCrud(): Observable<DadConfig[]> {
    return this.httpClient.get<DadConfig[]>(environment.baseUrlWs + '/api/user-dad-configs?active=1');
  }
}
